import { palette } from '@livable/saas-react-components';
const MuiTab = {
  styleOverrides: {
    root: {
      color: palette.shades[700],
      fontFamily: palette.fontFamilies.poppins,
      fontSize: '15px',
      lineHeight: '20px',
      transition: "color ".concat(palette.transitions.short),
      position: 'relative',
      textTransform: 'none',
      height: '59px',
      minHeight: 'initial',
      fontWeight: '600',
      '&:after': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '3px',
        backgroundColor: palette.shades[500],
        bottom: '0',
        borderRadius: '3px 3px 0 0',
        opacity: '0',
        transition: "opacity ".concat(palette.transitions.short)
      },
      '&.Mui-focusVisible': {
        color: palette.shades[800],
        '&:after': {
          opacity: '1'
        }
      },
      '&:hover': {
        color: palette.shades[800],
        '& path': {
          fill: palette.primary.dark
        },
        '&:after': {
          opacity: '1'
        }
      },
      '&.Mui-selected': {
        color: palette.shades[800],
        '&:hover': {
          '& .MuiSvgIcon-root path': {
            fill: palette.primary.dark
          }
        },
        '& .MuiSvgIcon-root path': {
          fill: palette.primary.dark
        }
      }
    },
    wrapper: {
      fontFamily: palette.fontFamilies.poppins,
      '& path': {
        fill: palette.shades[700]
      }
    }
  },
  variants: [{
    props: {
      variant: 'tabDivider'
    },
    style: {
      borderBottom: "1px solid ".concat(palette.shades[400])
    }
  }, {
    props: {
      type: 'wizardActionTop'
    },
    style: {
      marginBottom: '20px'
    }
  }, {
    props: {
      type: 'wizardActionBottom'
    },
    style: {
      marginTop: '20px'
    }
  }]
};
export default MuiTab;